import Vue from 'vue';
import VueRouter from 'vue-router';

import { start } from 'qiankun';
import Home from '../views/Home.vue';
import Recommend from '../views/Recommend.vue';
import Base from '../views/Base.vue';
import MicroBase from '../views/MicroBase.vue';
import IndividualCenter from '../views/IndividualCenter.vue';
import { getMicroAppList } from '../micro/index';
import { hasRoutePermission } from '../utils/utils';

const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);

const microRoutes = getMicroAppList().map((app) => (
  {
    path: `${app.activeRule}*`,
    name: `MicroBase_${app.name}`,
    component: MicroBase,
  }
));

const routes = [
  {
    path: '/',
    component: Base,
    children: [
      {
        path: '/',
        name: 'home',
        meta: {
          title: '首页',
        },
        component: Home,
      },
      {
        path: '/recommend',
        name: 'Recommend',
        meta: {
          title: '关于我们',
        },
        component: Recommend,
      },
      {
        path: '/IndividualCenter',
        name: 'IndividualCenter',
        meta: {
          title: '个人中心',
        },
        component: IndividualCenter,
      },
      ...microRoutes,
    ],
  },
  {
    path: '/login',
    name: 'OmsLogin',
    component: () => import(/* webpackChunkName: "OmsLogin" */ '../views/login/Login.vue'),
  },
  {
    path: '*',
    name: 'Page404',
    component: () => import(/* webpackChunkName: "Page404" */ '../views/404.vue'),
  },
  // 1版本=飞书审批
  {
    path: '/flyingBook',
    name: 'flyingBook',
    component: () => import(/* webpackChunkName: "flyingBook" */ '../views/flyingBook/index.vue'),
  },
  // 1版本=飞书审批
  {
    path: '/openAgain',
    name: 'openAgain',
    component: () => import(/* webpackChunkName: "openAgain" */ '../views/flyingBook/openAgain.vue'),
  },
  // 1版本=飞书审批
  {
    path: '/middle',
    name: 'middle',
    component: () => import(/* webpackChunkName: "middle" */ '../views/flyingBook/middle.vue'),
  },
  // 客端saas 跳转登录页
  {
    path: '/saasLogin',
    name: 'saasLogin',
    component: () => import(/* webpackChunkName: "middle" */ '../views/saas/login.vue'),
  },
  // 2版本 飞书审批
  {
    path: '/optimizeIndex',
    name: 'optimizeIndex',
    component: () => import(/* webpackChunkName: "middle" */ '../views/optimizeIndex/index.vue'),
  },
  // 2版本 飞书审批
  {
    path: '/push',
    name: 'push',
    component: () => import(/* webpackChunkName: "middle" */ '../views/optimizeIndex/push.vue'),
  },
  // 2版本 飞书审批
  {
    path: '/singleSignOn',
    name: 'singleSignOn',
    component: () => import(/* webpackChunkName: "middle" */ '../views/singleSignOn/index.vue'),
  },
  // 三方系统中转
  {
    path: '/tps',
    name: 'tps',
    component: () => import(/* webpackChunkName: "middle" */ '../views/tps/index.vue'),
  },
];
const router = new VueRouter({
  mode: 'history',
  routes,
});

router.beforeEach((to, _, next) => {
  console.log('main app router ===>', to);

  // 只对 /live/home 路由进行权限拦截
  if (to.path === '/live/home') {
    const hasPermission = hasRoutePermission(to.path);
    if (!hasPermission) {
      // 没有权限，重定向到基座的 Home 页
      console.warn('无权限访问路由:', to.path);
      next({ path: '/', replace: true });
      return;
    }
  }

  // 启动 qiankun 微前端
  start({
    prefetch: true, // prefetch: boolean | 'all' | string[] | function
  });

  next();
});

export default router;
